<template>
    <v-container fluid>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert = false" :info="info" />
        <v-card :style="{
      'border-radius': '2px',
      border:
        '1px solid' + $store.getters.getColorPalette().panelBorderColorCode,
    }"
    flat
    :dark="$store.getters.getColorPalette().isDark"
    :color="$store.getters.getColorPalette().background2ColorCode">
    <v-card-title>
        <span :style="{'color':  $store.getters.getColorPalette().accentCode}" class="text-h5">{{ $store.getters.getTextMap().checklist_status_stats }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
        <v-row>
            <v-col>
                <v-simple-table v-if="!loading" :dark="$store.getters.getColorPalette().isDark">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" >
                    <strong>{{$store.getters.getTextMap().stage}}</strong>
                  </th>
                  <th class="text-left" >
                    <strong>{{$store.getters.getTextMap().status}}</strong>
                  </th>
                  <th class="text-left" >
                    <strong>{{$store.getters.getTextMap().last_7_days}}</strong>
                  </th>
                  <th class="text-left" >
                    <strong>{{$store.getters.getTextMap().last_30_days}}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{$store.getters.getTextMap().last_365_days}}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                  
                <tr v-for="(item,index) in finalStats" :key="index">

                  <td :style="{'color':  $store.getters.getColorPalette().accentCode}"><strong>
                    {{ item.stage }}
                  </strong></td>
                  <td :style="{'color':  $store.getters.getColorPalette().accentCode}"><strong>
                    {{ textMap[item.status] }}
                  </strong></td>
                  <td :style="{'color':  $store.getters.getColorPalette().accentCode}">{{ item.last_7 }} </td>
                  <td :style="{'color':  $store.getters.getColorPalette().accentCode}">{{ item.last_30 }} </td>
                  <td :style="{'color':  $store.getters.getColorPalette().accentCode}">{{ item.last_365 }} </td>

                 
                </tr>
              </tbody>
            </template>
          </v-simple-table>
            </v-col>
        </v-row>

        
    </v-card-subtitle>

        </v-card>

        
    </v-container>
</template>

<script>
import InfoAlert from '@/components/InfoAlert.vue';
import axios from 'axios';
// import VueApexCharts from "vue-apexcharts";
import moment from 'moment';
export default {
    name: 'ChecklistCountStats',
    components: {
        InfoAlert,
        // apexchart: VueApexCharts,
    },
    mounted(){

        this.getStats()

    },
    data(){
        return {
            loading:false,
            showDismissibleAlert:false,
            info:'',
            tableData:[],
            statData:{},
            textMap:{
                'in_process':"Pending",
                'completed':"Completed",
                'rejected':"Rejected",
                'refill':'Refill requested (pending)'
            }
            


        }
    },
    computed:{
        finalStats(){

            return Object.values(this.statData)

        },
        


    },
    methods:{
        async updateStat(payload,timeKey='last_30'){
            // console.log(payload)
            this.loading=true
            try{

                let response = await axios.post(this.$store.state.api+'getChecklistCountStats',payload,{headers: {
                    Authorization: 'Bearer '+ this.$store.state.jwt}})
                    // console.log(response.data)
                  if(response.data.status==='success'){

                    this.tableData=response.data.data

                    let temp=response.data.data
                    let stats=Object.assign({},this.statData)
                    // console.log(temp)
                    let key=''
                    for(let k of temp){
                        // console.log(k)
                        key=k.stage.toString()+k.status.toString()
                        if (!(key in stats)){
                            stats[key]={
                                stage:k.stage,
                                status:k.status
                            }
                        }
                        stats[key][timeKey]=k.count;
                        
                    }
                    this.statData=stats;



                  }else{
                    this.info=response.data.msg
                    this.showDismissibleAlert=true
                  }
                }catch(err){
                    this.info=err
                    this.loading=false
                    this.showDismissibleAlert=true
                    
                }
                this.loading=false
                
            

        },
        async getStats(){
            this.statData={}
            await this.updateStat({timeParam:'created',from_time:moment().subtract(7,'days').unix()},'last_7');
            await this.updateStat({timeParam:'created',from_time:moment().subtract(30,'days').unix()},'last_30');
            await this.updateStat({timeParam:'created',from_time:moment().subtract(365,'days').unix()},'last_365');

        },


    }



}
</script>